/** @jsx jsx */
import { navigate } from 'gatsby'
import { Button, jsx, Text } from 'theme-ui'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import CartMeter from '~/components/Cart/Meter'
import { useBulkMeter } from '~/hooks/components/use-bulk-meter'
import { useCartFlyout } from '~/hooks/components/use-cart-flyout'

const CartBulkMeter = () => {
  const { closeCartFlyout } = useCartFlyout()
  const { casesNeededToBulkOrder, eligibleToBulkOrder, isEmpty, percentage } =
    useBulkMeter()
  const translate = useTranslate()

  const handleBulkContinue = () => {
    closeCartFlyout()
    navigate('/bulk/')
  }

  return (
    <CartMeter
      label={
        isEmpty
          ? translate('cart.meters.bulk.empty', {
              amount: casesNeededToBulkOrder,
            })
          : eligibleToBulkOrder
          ? translate('cart.meters.bulk.complete')
          : translate('cart.meters.bulk.incomplete', {
              amount: casesNeededToBulkOrder,
            })
      }
      percentage={percentage}
      footer={
        !isEmpty && (
          <Button variant="reset" onClick={() => handleBulkContinue()}>
            <Text
              as="strong"
              variant="body3"
              sx={{
                color: 'brandPrimary',
                fontWeight: 'bold',
                textDecoration: 'underline',
              }}
            >
              {translate('cart.bulk_continue')}
            </Text>
          </Button>
        )
      }
    />
  )
}

export default CartBulkMeter
